module.exports = __webpack_public_path__ + "img/block.966f1ec3.svg";